"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Accordion = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var styled_components_1 = __importDefault(require("styled-components"));
var AccordionItem_1 = require("./AccordionItem");
var useAccordion_1 = require("./useAccordion");
var AccordionWrapper = styled_components_1.default.dl(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n"], ["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n"])));
var getAccordionItems = function (items) {
    var e_1, _a;
    var parsedItems = [];
    try {
        for (var items_1 = __values(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()) {
            var item = items_1_1.value;
            if (Array.isArray(item.content)) {
                var parsedCategory = __assign(__assign({}, item), { content: (0, jsx_runtime_1.jsx)(exports.Accordion, { items: item.content }) });
                parsedItems.push(parsedCategory);
            }
            else {
                parsedItems.push(item);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return parsedItems.map(function (parsedItem, idx) {
        return ((0, jsx_runtime_1.jsx)(AccordionItem_1.AccordionItem, { data: parsedItem, index: idx }, idx));
    });
};
var Accordion = function (_a) {
    var items = _a.items;
    var _b = __read((0, useAccordion_1.useAccordion)(items.length), 3), activeIndex = _b[0], setActiveIndex = _b[1], collapseAll = _b[2];
    var AccordionItems = (0, react_1.useMemo)(function () { return getAccordionItems(items); }, [items]);
    var context = (0, react_1.useMemo)(function () {
        return { activeIndex: activeIndex, setActiveIndex: setActiveIndex, collapseAll: collapseAll };
    }, [activeIndex, setActiveIndex]);
    return ((0, jsx_runtime_1.jsx)(useAccordion_1.AccordionContext.Provider, __assign({ value: context }, { children: (0, jsx_runtime_1.jsx)(AccordionWrapper, { children: AccordionItems }) })));
};
exports.Accordion = Accordion;
var templateObject_1;
